"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.setCurrent = void 0;

var _ = require(".");

var _spec = require("./spec");

var _lodash = require("lodash");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var resource = _spec.RESOURCES.partySubscriptions;
var SET_CURRENT_PARTY_SUBSCRIPTION = new _.Action('SET_CURRENT_PARTY_SUBSCRIPTION');
var initialState = {
  pendingRequests: 0,
  errors: {},
  plan_error: {},
  data: {},
  currentPartySubscription: {},
  isLoading: false,
  isGettingFirstPage: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentPendingRequests;

  switch (action.type) {
    case resource.actions.create.main:
    case resource.actions.retrieve.main:
    case resource.actions.destroy.main:
    case resource.actions.update.main:
      currentPendingRequests = state.pendingRequests + 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        plan_error: {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.list.main:
      currentPendingRequests = state.pendingRequests + 1;
      var isGettingFirstPage = !action.payload.request.params.page ? true : false;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: {},
        plan_error: {},
        isGettingFirstPage: isGettingFirstPage,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.list.success:
      currentPendingRequests = state.pendingRequests - 1;
      var resultByKey = (0, _lodash.keyBy)(action.payload.results, 'id');
      var data = (0, _utils.isFirstPage)(action.payload) ? resultByKey : _objectSpread(_objectSpread({}, state.data), resultByKey);
      return _objectSpread(_objectSpread({}, state), {}, {
        data: data,
        next: action.payload.pages.next,
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.create.success:
    case resource.actions.retrieve.success:
    case resource.actions.update.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, action.payload.id, action.payload)),
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case SET_CURRENT_PARTY_SUBSCRIPTION.main:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPartySubscription: action.payload.partySubscription
      });

    case resource.actions.destroy.success:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        data: (0, _lodash.omit)(state.data, action.meta.object.id),
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    case resource.actions.create.fail:
    case resource.actions.list.fail:
    case resource.actions.retrieve.fail:
    case resource.actions.destroy.fail:
      currentPendingRequests = state.pendingRequests - 1;
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: action.payload,
        plan_error: action.payload.code === 'plan_error' ? action.payload : {},
        pendingRequests: currentPendingRequests,
        isLoading: currentPendingRequests > 0
      });

    default:
      return state;
  }
}

var setCurrent = function setCurrent(partySubscription) {
  return {
    type: SET_CURRENT_PARTY_SUBSCRIPTION.main,
    payload: {
      partySubscription: partySubscription
    }
  };
};

exports.setCurrent = setCurrent;